import { render, staticRenderFns } from "./BaseRow.vue?vue&type=template&id=76b2244b&scoped=true"
import script from "./BaseRow.vue?vue&type=script&lang=js"
export * from "./BaseRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b2244b",
  null
  
)

export default component.exports